import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase/supabase';

export const useNewsletter = (userId, userEmail) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading]           = useState(false);
  const [saving, setSaving]             = useState(false);
  const [error, setError]               = useState(null);

  const fetchSubscription = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const { data, error: err } = await supabase
        .from('d2f_newsletter_subscriptions')
        .select('*')
        .eq('user_id', userId)
        .maybeSingle();
      if (err) throw err;
      setSubscription(data);
    } catch (err) {
      console.error('[useNewsletter] fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { fetchSubscription(); }, [fetchSubscription]);

  const saveSubscription = async ({ email, isActive, frequency, preferences }) => {
    if (!userId) return;
    setSaving(true);
    setError(null);
    try {
      const { data, error: err } = await supabase.rpc('upsert_newsletter_subscription', {
        p_user_id:     userId,
        p_email:       email || userEmail || '',
        p_is_active:   isActive,
        p_frequency:   frequency,
        p_preferences: preferences,
      });
      if (err) throw err;
      setSubscription(data);
      return { success: true };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setSaving(false);
    }
  };

  const unsubscribe = () =>
    saveSubscription({
      email:       subscription?.email || userEmail,
      isActive:    false,
      frequency:   subscription?.frequency || 'weekly',
      preferences: subscription?.preferences || { genres: [], followed_only: true },
    });

  return { subscription, loading, saving, error, saveSubscription, unsubscribe, refetch: fetchSubscription };
};